export default {
  DESKTOP: 1200,
  TABLET_LANDSCAPE: 900, // 56.25em
  TABLET_PORTRAIT: 600,
};
